import React from "react";
import Hero from "../components/home/Hero";
import Stats from "../components/home/Stats";
import WhyChooseUs from "../components/home/WhyChooseUs";
import ServicesShowcase from "../components/home/ServicesShowcase";
import ProcessSection from "../components/home/ProcessSection";
import ProjectsCarousel from "../components/home/ProjectsCarousel";
import AboutTeaser from "../components/home/AboutTeaser";
import Testimonials from "../components/home/Testimonials";
import CTASection from "../components/home/CTASection";
import Seo from "../components/Seo";
import useReveal from "../hooks/useReveal";
import { useState, useEffect } from "react";
import api from "../lib/api";

export default function Home() {
  useReveal();
  const [rating, setRating] = useState(null);
  useEffect(() => {
    api.get("/settings")
      .then((r) => setRating({ value: r.data.rating_value, count: r.data.rating_count }))
      .catch(() => {});
  }, []);
  return (
    <>
      <Seo path="/" rating={rating} />
      <Hero />
      <Stats />
      <WhyChooseUs />
      <ServicesShowcase />
      <ProcessSection />
      <ProjectsCarousel />
      <AboutTeaser />
      <Testimonials />
      <CTASection />
    </>
  );
}
